export enum BondInsuranceStatusEnum {
  created = 'CREATED',
  canceled = 'CANCELED',
  expired = 'EXPIRED',
  overdue = 'OVERDUE',
  expiredPolicy = 'EXPIRED_POLICY'
}
